import { AppointmentPage } from 'old/pages/appointment-page/appointment-page'
import { TokenList } from 'old/pages/token/token-list/token-list'
import { Layout } from 'old/components/layout/layout/layout'
import { Dashboard } from 'old/pages/dashboard/dashboard'
import { FlowList } from 'old/pages/flow/flow-list/flow-list'
import { Login } from 'old/pages/login/login'
import { MessagePage } from 'old/pages/message-page/message-page'
import { PasswordReset } from 'old/pages/password-reset/password-reset'
import { Plans } from 'old/pages/plans/plans'
import { Profile } from 'old/pages/profile/profile'
import { ServiceList } from 'old/pages/service/service-list/service-list'
import { SettingsPage } from 'old/pages/settings/settings'
import { TeamMembersList } from 'old/pages/team-member/team-members-list/team-members-list'
import { RouteObject } from 'react-router-dom'
import { UserList } from 'old/pages/user/user-list/user-list'
import { CreateFlow } from 'old/pages/flow/create-flow/create-flow'
import { EditFlow } from 'old/pages/flow/edit-flow/edit-flow'
import { FlowPresets } from 'old/pages/flow/flow-presets/flow-presets'
import { UserForm } from 'old/pages/user/user-form/user-form'
import { ServiceForm } from 'old/pages/service/service-form/service-form'
import { TeamMemberForm } from 'old/pages/team-member/team-member-form/team-member-form'
import { BookingPage } from 'old/pages/booking/booking-page/booking-page'
import { BookingDraft } from 'old/pages/booking/booking-draft/booking-draft'
import { CalendarPage } from 'old/pages/calendar-page/calendar-page'
import { Config, Feature }  from 'old/types'
import { AppForm } from 'old/pages/app/app-form/app-form'
import { RegisteredAppsList } from 'old/pages/app/registered-apps-list/registered-apps-list'
import { AppLoader } from 'old/pages/app/app-loader/app-loader'
import { AllAppsList } from 'old/pages/app/all-apps-list/all-apps-list'
import { AppPermissionPage } from 'old/pages/app/app-permissions/app-permissions'
import { ErrorPage400, ErrorPage404, ErrorPage500 } from 'old/pages/error-page/error-page'
import { InstalledAppsList } from 'old/pages/app/installed-apps-list/installed-apps-list'
import { TokenForm } from 'old/pages/token/token-form/token-form'
import { Locale } from 'components/styled'

//isMenuDisabled:
export const isMenuEnable = (navTo: string, config: Config) => {
    switch(navTo){
        case '/flow':
            return config.features.includes(Feature.FLOWS)
        default:
            return true
    }
}

//isMenuHidden:
export const isMenuVisible = (navTo: string, config: Config) => {
    switch(navTo){
        case '/app':
        case '/developers':
            return config.features.includes(Feature.APPS)
        case '/token':
            return config.features.includes(Feature.PERSONAL_ACCESS_TOKEN)
        default:
            return true
    }
}

//getBookingRoute:
const getBookingRoute = () => (
    {
        path: 'book',
        children: [
            {
                path: '',
                element: <BookingPage/>
            },
            {
                path: ':serviceId',
                element: <BookingPage/>
            },
            {
                path: 'draft/:bookingId',
                element: <BookingDraft/>
            }
        ]
    }
)

//routes:
export const routes: RouteObject[] = [
    {
        path: '/login',
        element: <Locale><Login/></Locale>
    },
    {
        path: '/password-reset',
        element: <Locale><PasswordReset/></Locale>
    },
    {
        path: '/message',
        element: <Locale><MessagePage/></Locale>
    },
    {
        path: '400',
        element: <Locale><ErrorPage400/></Locale>
    },
    {
        path: '500',
        element: <Locale><ErrorPage500/></Locale>
    },
    {
        path: '*',
        element: <Locale><ErrorPage404/></Locale>
    },
    {
        path: '/',
        element: <Locale><Layout/></Locale>,
        children: [
            {
                path: '',
                element: <Dashboard/>
            },
            {
                path: 'profile',
                element: <Profile/>
            },
            {
                path: 'appointments',
                element: <AppointmentPage/>
            },
            {
                path: 'calendar',
                children: [
                    {
                        path: '',
                        element: <CalendarPage/>
                    },
                    {
                        path: 'reschedule/:appointmentId',
                        element: <BookingPage/>
                    },
                    getBookingRoute()
                ]
            },
            {
                path: 'service',
                children: [
                    {
                        path: '',
                        element: <ServiceList/>
                    },
                    {
                        path: ':id',
                        element: <ServiceForm/>
                    },
                    getBookingRoute()
                ]
            },
            {
                path: 'team',
                children: [
                    {
                        path: '',
                        element: <TeamMembersList/>
                    },
                    {
                        path: 'new',
                        element: <TeamMemberForm/>
                    },
                    {
                        path: ':id',
                        element: <TeamMemberForm/>
                    }
                ]
            },
            {
                path: 'flow',
                children: [
                    {
                        path: '',
                        element: <FlowList/>
                    },
                    {
                        path: 'presets',
                        element: <FlowPresets/>
                    },
                    {
                        path: 'new',
                        element: <CreateFlow/>
                    },
                    {
                        path: 'new/:presetId',
                        element: <CreateFlow/>
                    },
                    {
                        path: ':id',
                        element: <EditFlow/>
                    }
                ]
            },
            {
                path: 'user',
                children: [
                    {
                        path: '',
                        element: <UserList/>
                    },
                    {
                        path: 'new',
                        element: <UserForm/>
                    },
                    {
                        path: ':id',
                        element: <UserForm/>
                    }
                ]
            },
            {
                path: 'token',
                children: [
                    {
                        path: '',
                        element: <TokenList/>
                    },
                    {
                        path: 'new',
                        element: <TokenForm/>
                    }
                ]
            },
            {
                path: 'app',
                children: [
                    {
                        path: '',
                        element: <InstalledAppsList/>
                    },
                    {
                        path: 'all',
                        element: <AllAppsList/>
                    },
                    {
                        path: ':id',
                        element: <AppLoader/>
                    },
                    {
                        path: 'permission',
                        element: <AppPermissionPage/>
                    },
                ]
            },
            {
                path: 'developers',
                children: [
                    {
                        path: '',
                        element: <RegisteredAppsList/>
                    },
                    {
                        path: 'register',
                        element: <AppForm/>
                    },
                    {
                        path: ':id',
                        element: <AppForm/>
                    }
                ]
            },
            {
                path: 'settings',
                children: [
                    {
                        path: '',
                        element: <SettingsPage/>
                    },
                    {
                        path: 'plans',
                        element: <Plans/>
                    }
                ]
            }
        ]
    }
]
